import React, { useState } from 'react';
import "./Profile.css";
import profile from "../Profile";
import { useTranslation } from 'react-i18next';
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useAuth } from '../../contexts/AuthProvider';
import { API_URL } from "../../utils/config";
const baseUrl = API_URL;

const Preferences = () => {
  const { t, i18n } = useTranslation("profile");
  const [isDel, setIsDel] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [currPassword, setCurrPassword] = useState("");
  const [currentVisible, setCurrentVisible] = useState(false);
  const [deleteError, setDeleteError] = useState("");
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const getLangFromLocalStorage = () => {
    return localStorage.getItem("language") || "en";
  };

  // Function to handle language change and update profile
  const toggleLanguage = async () => {
    const nextLang = i18n.language === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(nextLang);
    localStorage.setItem('language', nextLang);
    
    // Call update-profile API to update the language in the profile
    try {
      const response = await fetch(`${baseUrl}/api/v1/attnd-supplier/auth/update-profile`, {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          lang: getLangFromLocalStorage(),

        },
        body: JSON.stringify({
          lang: nextLang,  // Send the language key (either 'en' or 'ar')
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to update profile language");
      }

      // Refresh the page after updating the language
      window.location.reload();
    } catch (error) {
      console.error("Error updating profile language:", error);
      // alert(error.message);
    }
  };

  const handleDelete = async () => {
    if (isDeleting) return;
    if (!isConfirmed) {
      setIsConfirmed(true);
      return;
    }

    // Clear previous errors
    setDeleteError("");

    // Password validation
    if (!currPassword || currPassword.trim() === "") {
      setDeleteError(t("preferences.deleteConfirm.passwordRequired") || "Password is required");
      return;
    }

    if (currPassword.length < 8) {
      setDeleteError(t("preferences.deleteConfirm.passwordTooShort") || "Password must be at least 8 characters long");
      return;
    }

    setIsDeleting(true);
    try {
      const response = await fetch(`${baseUrl}/api/v1/attnd-supplier/auth/delete-account`, {
        method: "DELETE",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          lang: getLangFromLocalStorage(),

        },
        body: JSON.stringify({ currentPassword: currPassword }),
      });
      if (!response.ok) {
        if (response.status === 401) {
          navigate('/login');
          throw new Error('Unauthorized access. Please log in again.');
        }
        const error = await response.json();
        throw new Error(error.error || error.message || 'An error occurred');
      }
      localStorage.clear();
      navigate('/');
    } catch (error) {
      console.error("Error deleting the session:", error);
      setDeleteError(error.message || 'An unexpected error occurred');
    } finally {
      setIsDeleting(false);
    }
  };

  const p_class = "font-inter font-normal font-semibold text-xl leading-[150%] text-center tracking-[0.01em] p-0 m-0 text-[#464646]";

  return (
    <div className="flex flex-col gap-4 pt-[64px] pl-[24px]">
      {/* Currency */}
      <div className="box-border flex flex-row justify-between items-center p-3 w-[688px] h-[54px] bg-white border border-[#EBE5FF] rounded-md">
        <div className="flex flex-row items-center p-0 h-[30px] gap-[88px]">
          <p className={p_class}>
            {t("preferences.currency.label")} <span style={{ marginLeft: '6px' }}>|</span>
          </p>
          <p className={p_class}>{profile.currency || "SAR"}</p>
        </div>
        {/* <p
          className="flex flex-row items-center p-0 gap-2 h-6 font-inter font-normal text-base leading-[150%] text-center tracking-[0.01em] cursor-pointer text-[#6609F8]"
        >
          {t("preferences.currency.change")}
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z" fill="#6609F8"/>
            <path d="M12.0014 17.4701C10.6014 17.4701 9.20141 16.9401 8.13141 15.8701C7.85141 15.5901 7.6014 15.2801 7.3714 14.9101C7.1514 14.5601 7.26139 14.1001 7.61139 13.8801C7.96139 13.6601 8.42142 13.7701 8.64142 14.1201C8.81142 14.4001 8.99141 14.6201 9.19141 14.8201C10.7414 16.3701 13.2614 16.3701 14.8114 14.8201C15.4114 14.2201 15.7914 13.4401 15.9214 12.5701C15.9814 12.1601 16.3614 11.8601 16.7714 11.9301C17.1814 11.9901 17.4614 12.3701 17.4114 12.7801C17.2414 13.9701 16.7114 15.0401 15.8814 15.8801C14.8014 16.9401 13.4014 17.4701 12.0014 17.4701Z" fill="#6609F8"/>
            <path d="M7.3399 12.08C7.2999 12.08 7.26991 12.08 7.22991 12.07C6.81991 12.01 6.5299 11.6299 6.5899 11.2199C6.7599 10.0299 7.2899 8.95996 8.1199 8.11996C10.2499 5.98996 13.7199 5.98996 15.8599 8.11996C16.1399 8.39996 16.3899 8.70999 16.6199 9.08999C16.8399 9.43999 16.7299 9.89996 16.3799 10.12C16.0299 10.34 15.5699 10.23 15.3499 9.87997C15.1799 9.60997 14.9999 9.37996 14.7999 9.17996C13.2499 7.62996 10.7299 7.62996 9.17989 9.17996C8.57989 9.77996 8.19991 10.56 8.06991 11.43C8.02991 11.81 7.7099 12.08 7.3399 12.08Z" fill="#6609F8"/>
            <path d="M7.82031 17.9297C7.41031 17.9297 7.07031 17.5897 7.07031 17.1797V14.5098C7.07031 14.0998 7.41031 13.7598 7.82031 13.7598H10.4903C10.9003 13.7598 11.2403 14.0998 11.2403 14.5098C11.2403 14.9198 10.9003 15.2598 10.4903 15.2598Z" fill="#6609F8"/>
            <path d="M16.1778 10.2403H13.5078C13.0978 10.2403 12.7578 9.9003 12.7578 9.4903C12.7578 9.0803 13.0978 8.7403 13.5078 8.7403H15.4278V6.82031C15.4278 6.41031 15.7678 6.07031 16.1778 6.07031C16.5878 6.07031 16.9278 6.41031 16.9278 6.82031V9.4903C16.9278 9.9103 16.5878 10.2403 16.1778 10.2403Z" fill="#6609F8"/>
          </svg>
        </p> */}
      </div>

      {/* Language */}
      <div
        className="box-border flex flex-row justify-between items-center p-3 w-[688px] h-[54px] bg-white border border-[#EBE5FF] rounded-md cursor-pointer"
        onClick={toggleLanguage}
      >
        <div className="flex flex-row items-center p-0 h-[30px] gap-[88px]">
          <p className={p_class}>{t("preferences.language.label")} |</p>
          <p className={p_class}>
            {i18n.language === 'en'
              ? t("preferences.language.value.en")
              : t("preferences.language.value.ar")}
          </p>
        </div>
        <p className="flex flex-row items-center p-0 gap-2 h-6 font-inter font-normal text-base leading-[150%] tracking-[0.01em] cursor-pointer text-[#6609F8]">
          {t("preferences.language.change")}
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z" fill="#6609F8"/>
            <path d="M12.0014 17.4701C10.6014 17.4701 9.20141 16.9401 8.13141 15.8701C7.85141 15.5901 7.6014 15.2801 7.3714 14.9101C7.1514 14.5601 7.26139 14.1001 7.61139 13.8801C7.96139 13.6601 8.42142 13.7701 8.64142 14.1201C8.81142 14.4001 8.99141 14.6201 9.19141 14.8201C10.7414 16.3701 13.2614 16.3701 14.8114 14.8201C15.4114 14.2201 15.7914 13.4401 15.9214 12.5701C15.9814 12.1601 16.3614 11.8601 16.7714 11.9301C17.1814 11.9901 17.4614 12.3701 17.4114 12.7801C17.2414 13.9701 16.7114 15.0401 15.8814 15.8801C14.8014 16.9401 13.4014 17.4701 12.0014 17.4701Z" fill="#6609F8"/>
            <path d="M7.3399 12.08C7.2999 12.08 7.26991 12.08 7.22991 12.07C6.81991 12.01 6.5299 11.6299 6.5899 11.2199C6.7599 10.0299 7.2899 8.95996 8.1199 8.11996C10.2499 5.98996 13.7199 5.98996 15.8599 8.11996C16.1399 8.39996 16.3899 8.70999 16.6199 9.08999C16.8399 9.43999 16.7299 9.89996 16.3799 10.12C16.0299 10.34 15.5699 10.23 15.3499 9.87997C15.1799 9.60997 14.9999 9.37996 14.7999 9.17996C13.2499 7.62996 10.7299 7.62996 9.17989 9.17996C8.57989 9.77996 8.19991 10.56 8.06991 11.43C8.02991 11.81 7.7099 12.08 7.3399 12.08Z" fill="#6609F8"/>
            <path d="M7.82031 17.9297C7.41031 17.9297 7.07031 17.5897 7.07031 17.1797V14.5098C7.07031 14.0998 7.41031 13.7598 7.82031 13.7598H10.4903C10.9003 13.7598 11.2403 14.0998 11.2403 14.5098C11.2403 14.9198 10.9003 15.2598 10.4903 15.2598Z" fill="#6609F8"/>
            <path d="M16.1778 10.2403H13.5078C13.0978 10.2403 12.7578 9.9003 12.7578 9.4903C12.7578 9.0803 13.0978 8.7403 13.5078 8.7403H15.4278V6.82031C15.4278 6.41031 15.7678 6.07031 16.1778 6.07031C16.5878 6.07031 16.9278 6.41031 16.9278 6.82031V9.4903C16.9278 9.9103 16.5878 10.2403 16.1778 10.2403Z" fill="#6609F8"/>
          </svg>
        </p>
      </div>

      {/* Delete Account */}
      <div
        className="box-border flex flex-row justify-between items-center p-3 w-[688px] h-[54px] bg-white border border-[#EBE5FF] rounded-md cursor-pointer"
        onClick={() => setIsDel(true)}
      >
        <p className="font-inter font-semibold text-xl leading-[150%] tracking-[0.01em] text-[#DC3545]">
          {t("preferences.deleteAccount.heading")}
        </p>
        <div className="flex flex-row items-center p-0 gap-2 h-6">
          <p className="h-6 font-inter font-normal text-base leading-[150%] tracking-[0.01em] text-[#DC3545]">
            {t("preferences.deleteAccount.button")}
          </p>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.9997 6.72998C20.9797 6.72998 20.9497 6.72998 20.9197 6.72998C15.6297 6.19998 10.3497 5.99998 5.11967 6.52998L3.07967 6.72998C2.65967 6.76998 2.28967 6.46998 2.24967 6.04998C2.20967 5.62998 2.50967 5.26998 2.91967 5.22998L4.95967 5.02998C10.2797 4.48998 15.6697 4.69998 21.0697 5.22998C21.4797 5.26998 21.7797 5.63998 21.7397 6.04998C21.7097 6.43998 21.3797 6.72998 20.9997 6.72998Z" fill="#DC3545"/>
            <path d="M8.50074 5.72C8.46074 5.72 8.42074 5.72 8.37074 5.71C7.97074 5.64 7.69074 5.25 7.76074 4.85L7.98074 3.54C8.14074 2.58 8.36074 1.25 10.6907 1.25H13.3107C15.6507 1.25 15.8707 2.63 16.0207 3.55L16.2407 4.85C16.3107 5.26 16.0307 5.65 15.6307 5.71C15.2207 5.78 14.8307 5.5 14.7707 5.1L14.5507 3.8C14.4107 2.93 14.3807 2.76 13.3207 2.76H10.7007C9.64074 2.76 9.62074 2.9 9.47074 3.79L9.24074 5.09C9.18074 5.46 8.86074 5.72 8.50074 5.72Z" fill="#DC3545"/>
            <path d="M15.2104 22.7501H8.79039C5.30039 22.7501 5.16039 20.8201 5.05039 19.2601L4.40039 9.19007C4.37039 8.78007 4.69039 8.42008 5.10039 8.39008C5.52039 8.37008 5.87039 8.68008 5.90039 9.09008L6.55039 19.1601C6.66039 20.6801 6.70039 21.2501 8.79039 21.2501H15.2104C17.3104 21.2501 17.3504 20.6801 17.4504 19.1601L18.1004 9.09008C18.1304 8.68008 18.4904 8.37008 18.9004 8.39008C19.3104 8.42008 19.6304 8.77007 19.6004 9.19007L18.9504 19.2601C18.8404 20.8201 18.7004 22.7501 15.2104 22.7501Z" fill="#DC3545"/>
            <path d="M13.6581 17.25H10.3281C9.91813 17.25 9.57812 16.91 9.57812 16.5C9.57812 16.09 9.91813 15.75 10.3281 15.75H13.6581C14.0681 15.75 14.4081 16.09 14.4081 16.5C14.4081 16.91 14.0681 17.25 13.6581 17.25Z" fill="#DC3545"/>
            <path d="M14.5 13.25H9.5C9.09 13.25 8.75 12.91 8.75 12.5C8.75 12.09 9.09 11.75 9.5 11.75H14.5C14.91 11.75 15.25 12.09 15.25 12.5C15.25 12.91 14.91 13.25 14.5 13.25Z" fill="#DC3545"/>
          </svg>
        </div>
      </div>

      {isDel && (
        <div>
          <div className="box-border flex flex-col items-center fixed w-[393px] h-[305px] left-[calc(50%-196px)] top-[calc(50%-153px)] bg-white shadow-lg backdrop-filter backdrop-blur-[25px] rounded-t-lg">
            <div className="flex flex-row justify-between items-center p-2 px-4 w-[393px] h-[46px]">
              <p className="font-inter font-semibold text-xl leading-[25px] text-[#292929] m-0">
                {t("preferences.deleteAccount.heading")}
              </p>
              <svg
                onClick={() => {
                  setIsDel(false);
                  setIsConfirmed(false);
                  setDeleteError("");
                  setCurrPassword("");
                }}
                style={{ cursor: "pointer" }}
                width="30" height="30" viewBox="0 0 30 30" fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="30" height="30" rx="15" fill="#DBDBDB"/>
                <path
                  d="M9.92188 20.4531C9.79167 20.3229 9.70573 20.1719 9.66406 20C9.6224 19.8229 9.6224 19.6484 9.66406 19.4766C9.70573 19.3047 9.78906 19.1562 9.91406 19.0312L13.5781 15.3672L9.91406 11.7109C9.78906 11.5859 9.70573 11.4375 9.66406 11.2656C9.6224 11.0938 9.6224 10.9219 9.66406 10.75C9.70573 10.5729 9.79167 10.4193 9.92188 10.2891C10.0469 10.1641 10.1953 10.0807 10.3672 10.0391C10.5443 9.99219 10.7188 9.99219 10.8906 10.0391C11.0677 10.0807 11.2188 10.1615 11.3438 10.2812L15 13.9453L18.6641 10.2891C18.7891 10.1641 18.9349 10.0807 19.1016 10.0391C19.2734 9.99219 19.4453 9.99219 19.6172 10.0391C19.7943 10.0807 19.9453 10.1667 20.0703 10.2969C20.2057 10.4219 20.2943 10.5729 20.3359 10.75C20.3776 10.9219 20.3776 11.0938 20.3359 11.2656C20.2943 11.4375 20.2083 11.5859 20.0781 11.7109L16.4297 15.3672L20.0781 19.0312C20.2083 19.1562 20.2943 19.3047 20.3359 19.4766C20.3776 19.6484 20.3776 19.8229 20.3359 20C20.2943 20.1719 20.2057 20.3203 20.0703 20.4453C19.9453 20.5755 19.7943 20.6641 19.6172 20.7109C19.4453 20.7526 19.2734 20.7526 19.1016 20.7109C18.9349 20.6693 18.7891 20.5833 18.6641 20.4531L15 16.7969L11.3438 20.4609C11.2188 20.5807 11.0677 20.6641 10.8906 20.7109C10.7188 20.7526 10.5443 20.7526 10.3672 20.7109C10.1953 20.6641 10.0469 20.5781 9.92188 20.4531Z"
                  fill="#464646"
                />
              </svg>
            </div>
            <div className="box-border flex flex-col w-[393px] min-h-[248px]">
              {/* Content Area - flexible height */}
              <div className="flex-grow px-4 py-2">
                {isConfirmed ? (
                  <div className="w-full flex flex-col gap-4 p-2">
                    <p className="text-sm font-medium">{t("preferences.deleteConfirm.currentPassword")}</p>
                    <div className="relative rounded-[4px]" style={{ border: "1px solid black" }}>
                      <input
                        className="w-full h-10 outline-none px-4 rounded-md"
                        type={currentVisible ? "text" : "password"}
                        value={currPassword}
                        onChange={(e) => setCurrPassword(e.target.value)}
                        placeholder={t("preferences.deleteConfirm.passwordPlaceholder") || "Enter your password"}
                      />
                      <span 
                        className="absolute cursor-pointer top-[8px] z-10" 
                        onClick={() => setCurrentVisible(v => !v)}
                        style={{
                          [i18n.language === "ar" ? "left" : "right"]: "8px"
                        }}
                      >
                        {currentVisible ? (
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="vuesax/outline/eye">
                              <g id="eye">
                                <path id="Vector" d="M12 16.3299C9.61004 16.3299 7.67004 14.3899 7.67004 11.9999C7.67004 9.60992 9.61004 7.66992 12 7.66992C14.39 7.66992 16.33 9.60992 16.33 11.9999C16.33 14.3899 14.39 16.3299 12 16.3299ZM12 9.16992C10.44 9.16992 9.17004 10.4399 9.17004 11.9999C9.17004 13.5599 10.44 14.8299 12 14.8299C13.56 14.8299 14.83 13.5599 14.83 11.9999C14.83 10.4399 13.56 9.16992 12 9.16992Z" fill="#4D4D4D"/>
                                <path id="Vector_2" d="M12 21.02C8.23996 21.02 4.68996 18.82 2.24996 15C1.18996 13.35 1.18996 10.66 2.24996 8.99998C4.69996 5.17998 8.24996 2.97998 12 2.97998C15.75 2.97998 19.3 5.17998 21.74 8.99998C22.8 10.65 22.8 13.34 21.74 15C19.3 18.82 15.75 21.02 12 21.02ZM12 4.47998C8.76996 4.47998 5.67996 6.41998 3.51996 9.80998C2.76996 10.98 2.76996 13.02 3.51996 14.19C5.67996 17.58 8.76996 19.52 12 19.52C15.23 19.52 18.32 17.58 20.48 14.19C21.23 13.02 21.23 10.98 20.48 9.80998C18.32 6.41998 15.23 4.47998 12 4.47998Z" fill="#4D4D4D"/>
                              </g>
                            </g>
                          </svg>
                        ) : (
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.47188 15.2799C9.28188 15.2799 9.09187 15.2099 8.94187 15.0599C8.12187 14.2399 7.67188 13.1499 7.67188 11.9999C7.67188 9.60992 9.61187 7.66992 12.0019 7.66992C13.1519 7.66992 14.2419 8.11992 15.0619 8.93992C15.2019 9.07992 15.2819 9.26992 15.2819 9.46992C15.2819 9.66992 15.2019 9.85992 15.0619 9.99992L10.0019 15.0599C9.85187 15.2099 9.66188 15.2799 9.47188 15.2799ZM12.0019 9.16992C10.4419 9.16992 9.17188 10.4399 9.17188 11.9999C9.17188 13.5599 10.4419 14.8299 12.0019 14.8299C13.5619 14.8299 14.8319 13.5599 14.8319 11.9999C14.8319 10.4399 13.5619 9.16992 12.0019 9.16992Z" fill="#464646"/>
                            <path d="M5.59984 18.51C5.42984 18.51 5.24984 18.45 5.10984 18.33C4.03984 17.42 3.07984 16.3 2.25984 15C1.19984 13.35 1.19984 10.66 2.25984 8.99998C4.69984 5.17998 8.24984 2.97998 11.9998 2.97998C14.1998 2.97998 16.3698 3.73998 18.2698 5.16998C18.5998 5.41998 18.6698 5.88998 18.4198 6.21998C18.1698 6.54998 17.6998 6.61998 17.3698 6.36998C15.7298 5.12998 13.8698 4.47998 11.9998 4.47998C8.76984 4.47998 5.67984 6.41998 3.51984 9.80998C2.76984 10.98 2.76984 13.02 3.51984 14.19C4.26984 15.36 5.12984 16.37 6.07984 17.19C6.38984 17.46 6.42984 17.93 6.15984 18.25C6.01984 18.42 5.80984 18.51 5.59984 18.51Z" fill="#464646"/>
                            <path d="M11.9986 21.02C10.6686 21.02 9.3686 20.75 8.1186 20.22C7.7386 20.06 7.5586 19.62 7.7186 19.24C7.8786 18.86 8.3186 18.68 8.6986 18.84C9.7586 19.29 10.8686 19.52 11.9886 19.52C15.2186 19.52 18.3086 17.58 20.4686 14.19C21.2186 13.02 21.2186 10.98 20.4686 9.81C20.1586 9.32 19.8186 8.85 19.4586 8.41C19.1986 8.09 19.2486 7.62 19.5686 7.35C19.8886 7.09 20.3586 7.13 20.6286 7.46C21.0186 7.94 21.3986 8.46 21.7386 9C22.7986 10.65 22.7986 13.34 21.7386 15C19.2986 18.82 15.7486 21.02 11.9986 21.02Z" fill="#464646"/>
                            <path d="M12.6915 16.2699C12.3415 16.2699 12.0215 16.0199 11.9515 15.6599C11.8715 15.2499 12.1415 14.8599 12.5515 14.7899C13.6515 14.5899 14.5715 13.6699 14.7715 12.5699C14.8515 12.1599 15.2415 11.8999 15.6515 11.9699C16.0615 12.0499 16.3315 12.4399 16.2515 12.8499C15.9315 14.5799 14.5515 15.9499 12.8315 16.2699Z" fill="#464646"/>
                            <path d="M2.00141 22.7502C1.81141 22.7502 1.62141 22.6802 1.47141 22.5302C1.18141 22.2402 1.18141 21.7602 1.47141 21.4702L8.94141 14.0002C9.23141 13.7102 9.71141 13.7102 10.0014 14.0002C10.2914 14.2902 10.2914 14.7702 10.0014 15.0602L2.53141 22.5302C2.38141 22.6802 2.19141 22.7502 2.00141 22.7502Z" fill="#464646"/>
                            <path d="M14.5287 10.2199C14.3387 10.2199 14.1488 10.1499 13.9988 9.99994C13.7088 9.70994 13.7088 9.22994 13.9988 8.93994L21.4687 1.46994C21.7587 1.17994 22.2388 1.17994 22.5288 1.46994C22.8188 1.75994 22.8188 2.23994 22.5288 2.52994L15.0588 9.99994C14.9088 10.1499 14.7187 10.2199 14.5287 10.2199Z" fill="#464646"/>
                          </svg>
                        )}
                      </span>
                    </div>
                    {currPassword && currPassword.length < 8 && (
                      <p className="text-red-500 text-sm">
                        {t("preferences.deleteConfirm.passwordTooShort") || "Password must be at least 8 characters long"}
                      </p>
                    )}
                  </div>
                ) : (
                  <div className="flex flex-col justify-center items-center py-8 gap-2">
                    <h5 className="font-inter font-bold text-base leading-6 text-[#292929] m-0 text-center">
                      {t("preferences.deleteConfirm.prompt")}
                    </h5>
                    <p className="font-inter font-normal text-base leading-6 text-[#464646] m-0 text-center">
                      {t("preferences.deleteConfirm.description")}
                    </p>
                  </div>
                )}
              </div>

              {/* Error Message - separate section */}
              {deleteError && (
                <div className="px-4 pb-2">
                  <p className="text-red-500 text-sm p-2 bg-red-50 rounded border border-red-200">
                    {deleteError}
                  </p>
                </div>
              )}

              {/* Buttons - fixed at bottom */}
              <div className="flex flex-row justify-center items-center p-4 gap-2 w-full border-t border-gray-100 mt-auto">
                <button
                  onClick={() => {
                    setIsDel(false);
                    setIsConfirmed(false);
                    setDeleteError("");
                    setCurrPassword("");
                  }}
                  className="box-border flex justify-center items-center p-3.5 px-5 gap-2 w-[176.5px] h-[48px] shadow-sm rounded-md bg-white border border-gray-200 font-inter font-medium text-base leading-[18px] text-[#292929] cursor-pointer"
                >
                  {t("preferences.deleteConfirm.cancel")}
                </button>
                <button
                  onClick={handleDelete}
                  disabled={isConfirmed && (!currPassword || currPassword.length < 8 || isDeleting)}
                  className={`box-border flex justify-center items-center p-3.5 px-5 gap-2 w-[176.5px] h-[48px] shadow-sm rounded-md text-white font-inter font-medium text-base leading-[18px] cursor-pointer ${
                    isConfirmed && (!currPassword || currPassword.length < 8 || isDeleting)
                      ? 'bg-gray-400 cursor-not-allowed'
                      : 'bg-[#DC3545]'
                  }`}
                >
                  {isDeleting
                    ? t("preferences.deleteConfirm.deleting")
                    : t("preferences.deleteConfirm.confirm")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default Preferences;
